import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import LoadList from './LoadList';
import groupLoadsBy from '../utils/groupLoadsBy';

const { Panel } = Collapse;

const GroupedLoadList = ({
  list,
  groupBy,
  loadSelected,
  setShowLoadList,
  setShowLoadDetail,
}) => {
  if (!groupBy) {
    return (
      <LoadList
        list={list}
        loadSelected={loadSelected}
        setShowLoadList={setShowLoadList}
        setShowLoadDetail={setShowLoadDetail}
      />
    );
  }

  const groups = groupLoadsBy(list, groupBy);

  return (
    <Collapse
      key={groupBy}
      className="loads-group-collapse"
      bordered={false}
      defaultActiveKey={[]}
    >
      {groups.map(group => (
        <Panel
          header={`${group.label} (${group.loads.length})`}
          key={group.key}
        >
          <LoadList
            list={group.loads}
            loadSelected={loadSelected}
            setShowLoadList={setShowLoadList}
            setShowLoadDetail={setShowLoadDetail}
          />
        </Panel>
      ))}
    </Collapse>
  );
};

GroupedLoadList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  groupBy: PropTypes.oneOf([null, 'destination', 'origin', 'product']),
  loadSelected: PropTypes.func.isRequired,
  setShowLoadList: PropTypes.func.isRequired,
  setShowLoadDetail: PropTypes.func.isRequired,
};

GroupedLoadList.defaultProps = {
  groupBy: null,
};

export default GroupedLoadList;
